import { downgradeInjectable } from '@angular/upgrade/static';
import { LocalStorageService } from '@fry-it/risr-core';

(function() {
  'use strict';

  angular.module('blocks.network')
    .service('kzLocalStorage', downgradeInjectable(LocalStorageService));
})();
